<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 mb-3 mt-3">
                <h1>Make Report </h1>
            </div>
        </div>
        <div class="row ">

            <!-- SELECTED APRON  -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-5 ">
                <div class="p-4 bg-white rounded-10 h-100 shadow">
                    <h2>Selected apron</h2>

                    <preview-plus-details v-model="selectedApron"></preview-plus-details>

                </div>
            </div>

            <!-- REPORT -->
            <div v-if="typeof selectedApron !== 'undefined'" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-5 ">


                <div v-if="currentStep == 1">
                    <div class="p-4 bg-white rounded-10 h-100 shadow">

                        <h2>{{ $tc('reportOverview.reports', 1) }}</h2>

                        <Questionnaire :question-title="$t('accountConfig.protectiveQualities') + '*'" v-model="report.scoreProtection"></Questionnaire>
                        <Questionnaire :question-title="$t('reportOverview.hygiene') + '*'" v-model="report.scoreHygiene"></Questionnaire>
                        <Questionnaire :question-title="$t('accountConfig.conditionFasteners') + '*'" v-model="report.scoreFasteners"></Questionnaire>

                        <!-- Warning message -->
                        <div v-if="isOutOfTolerance" class="message mt-2 border-red">
                            <b-icon-exclamation-circle-fill class="color-red large-text mr-2" /> {{ $t('reportPage.outOfToleranceWarning', [selectedApron.model.name]) }}
                        </div>

                        <!-- Notes and photo's -->
                        <div class="row">
                            <div class="col-12">
                                <h3 class="mt-4">{{ $t('reportPage.notesAndPhotos') }} <span class="small">({{ $t('general.optional') }})</span></h3>

                                <textarea v-model="report.notes" class="mt-2"></textarea>

                                <div class="mt-4">
                                    <span v-if="uploadBusy">{{ $t('reportPage.uploading') }}</span>
                                    <input id="FileSector" name="file" type="file" ref="file" v-on:change="uploadBusy=true;AppendFileList($event.target.files)" accept=".jpg, .png, .bmp" multiple="multiple" class="hide-upload-button" :disabled="lstFileNames.length >= 5" data-multiple-caption="{count} files selected">
                                    <label for="FileSector" class="upload-button blue-gradient d-inline mr-3" :disabled="lstFileNames.length >= 5" :class="{ 'disabled-button': lstFileNames.length >= 5 }"><b-icon-upload class="mr-2" /> <span>{{ $t('reportPage.upload') }}</span></label>
                                    <p class="d-inline-block small mt-4 ">({{ $t('reportPage.fileRestirctions') }})</p>

                                    <p v-for="(val, index) in fileValidation" :key="index" class="bg-light p-2 rounded mt-2"><b-icon-exclamation-circle-fill class="color-orange mr-1" /> {{val}}</p>

                                    <div v-if="lstFileNames.length > 0" class="mt-5 mb-4">
                                       
                                        <div class="row">
                                            <p class="mb-0 col-12">{ $t('reportPage.currentFiles') }}:</p>
                                            <div v-for="(file, index) in lstFileNames" :key="index" class="col-12 col-sm-6 col-md-6 col-lg-4 mt-4">
                                                <div class="image-preview text-center">
                                                    <button class="delete" v-on:click="DeletePhoto(index)"><b-icon-x /></button>
                                                    <img :src="file.src" class="w-100" />
                                                    <span class="small">{{file.name}}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <!--<div v-for="(path, index) in lstFilePath" :key="index" class="d-inline-block image-preview">
                                        <img :src="path" class="w-100" />
                                    </div>-->
                                </div>

                            </div>
                        </div>


                        <div class="row mt-4">
                            <div class="col-12 text-right">
                                <div class="border-top">
                                    <!--<span v-if="isOutOfTolerance" class="color-red mt-2 d-inline-block"><b-icon-exclamation-circle-fill /> This apron is out of tolerance.</span>-->
                                    <div v-if="tolerance == null" class="mt-4 mb-2 color-red ">
                                        <b-icon-exclamation-circle-fill />  
                                        <i18n path="reportPage.noToleranceMessage" tag="label" for="addEditApron.settingsPage">
                                            <a href="/LAA/settings" target="=_blank" class="small-button color-red">{{ $t('addEditApron.settingsPage') }}</a>
                                        </i18n>
                                    </div>
                                    <div v-else class="mt-4 mb-2">
                                        <div v-if="allowNext && allowSubmit && isOutOfTolerance == false && isOnEdge == false">
                                            <navigation-button mode="save" :allow-press="allowNext && allowSubmit && isOutOfTolerance == false && isOnEdge == false" @button-clicked="SubmitReport('Save', selectedApron.model.name )"></navigation-button>
                                        </div>
                                        <div v-else>
                                            <navigation-button mode="next" :allow-press="allowNext" @button-clicked="currentStep = 2"></navigation-button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- FOLLOW-UP -->

                <div v-else-if="currentStep == 2" class="col-12 col-sm-12 col-md-12 col-lg-12  mb-5 h-100 ">
                    <div class="p-3 bg-white rounded-10 h-100 shadow">

                        <div v-if="isOutOfTolerance">
                            <h2>{{ $t('reportPage.discardApron') }}</h2>



                            <div class="row mt-4">
                                <div class="col-12">
                                    <p>{{ $t('reportPage.outOfToleranceReminder') }}:</p>

                                    <div class="message">
                                        <p v-if="report.scoreProtection < tolerance.limProtection"><b-icon-exclamation-diamond class="color-red" /> {{ $t('accountConfig.protectiveQualities') }}</p>
                                        <p v-if="report.scoreHygiene < tolerance.limHygiene"><b-icon-exclamation-diamond class="color-red" /> {{ $t('reportOverview.hygiene') }}</p>
                                        <p v-if="report.scoreFasteners < tolerance.limFasteners"><b-icon-exclamation-diamond class="color-red mr-2" /> {{ $t('accountConfig.conditionFasteners') }}</p>
                                    </div>
                                </div>
                            </div>


                            <div class="row mt-3">
                                <div class="col-12">
                                    <p class="m-0">{{ $t('reportPage.approveAnywayMessage') }}</p>

                                    <!-- Approve anyway area -->
                                    <div class="bg-light p-2 mt-3 d-inline-block rounded">
                                        <input type="checkbox" v-model="report.ApproveAnyway" id="chkKeep" /> <label for="chkKeep" class="m-0 curser-pointer">{{ $t('reportPage.keepInInventory') }}</label>
                                    </div>

                                    <div v-if="report.ApproveAnyway == true" class="mt-2">
                                        <text-with-datepicker v-on:input="report.nextInspection = $event" :is-out-of-tolerance="isOutOfTolerance" :is-on-edge="isOnEdge" :text="$t('reportPage.keptInInventoryMessage')"></text-with-datepicker>
                                    </div>
                                </div>


                            </div>

                        </div>
                        <div v-else-if="isOnEdge">
                            <h2>{{ $t('reportPage.scheduleNextInspection') }}</h2>

                            <div class="row">
                                <div class="col-12">
                                    <text-with-datepicker v-on:input="report.nextInspection = $event" :is-out-of-tolerance="isOutOfTolerance" :is-on-edge="isOnEdge" :text="$t('reportPage.narrowestOfMargins')"></text-with-datepicker>
                                </div>

                            </div>

                        </div>

                        <!--SAVE BUTTONS-->
                        <div class="row mt-4">
                            <div class="col-12">
                                <div class="border-top">
                                    <div class="mt-4 mb-2">
                                        <div class="row">
                                            <div class="col-3">
                                                <navigation-button mode="back" :allow-press="true" @button-clicked="currentStep = 1"></navigation-button>
                                                <!--<button type="button" v-on:click="currentStep = 1" class="medium-button blue-gradient d-inline-block icon-button"><b-icon-arrow-left /><span class="d-none"> Back </span></button>-->
                                            </div>
                                            <div class="col-9 text-right">
                                                <div v-if="isOutOfTolerance" class="d-inline-block">
                                                    <button type="button" v-if="allowNext && allowSubmit && isOutOfTolerance && report.ApproveAnyway" v-on:click="SubmitReport('Save', selectedApron.model.name)" class="medium-button blue-gradient d-inline-block mr-3 icon-button"><b-icon-cloud-upload class="mr-lg-2" /><span class="d-md-inline-block d-sm-none d-none"> {{ $t('general.save') }} </span></button>
                                                    <button type="button" v-else-if="allowNext && allowSubmit  && isOutOfTolerance" v-on:click="SubmitReport('Discard', selectedApron.model.name, selectedApron.model.category)" class="medium-button red-gradient mr-3 icon-button  d-inline-block"><b-icon-trash-fill class="mr-lg-2" /><span class="d-md-inline-block d-sm-none d-none"> {{ $t('general.discard') }}</span></button>
                                                </div>
                                                <div v-else-if="isOnEdge" class="d-inline-block text-right">
                                                    <navigation-button mode="save" :allow-press="allowNext && allowSubmit && isOnEdge" @button-clicked="SubmitReport('Save', selectedApron.model.name)"></navigation-button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import { mapGetters, mapState } from 'vuex';
    import * as general from '../../scripts/General.js';
    import Questionnaire from "@/private/components/UI-elements/Questionnaire";
    import Vue from 'vue'
    import Router from 'vue-router'
    import Bus from '../../Bus.js';
    import TextWithDatepicker from "@/private/components/Reporting/TextWithDatepicker.vue"
    import NavigationButton from "@/private/components/UI-elements/NavigationButton.vue";
    import PreviewPlusDetails from "@/private/components/UI-elements/PreviewPlusDetails.vue";



    Vue.use(Router)

    export default {
        name: 'Report',

        components: {
            Questionnaire,
            TextWithDatepicker,
            NavigationButton,
            PreviewPlusDetails
        },

        props: {

        },
        data: function () {

            return {
                lstFilesToUpload: new FormData(),
                lstFileNames: [],
                lstFilePath: [],
                fileValidation: [],
                currentStep: 1,
				uploadBusy: false
            }

        },
        mounted: function () {
            this.GetEmptyReport();

            //Clear filter
            this.$store.commit('SET_searchTerm', '')
        },
        computed: {
			selectedApron: {
				get: function () {
					return this.$store.state.lstAllAprons.find(x => x.apronID == this.$route.params.slug)
				},
				set: function () {
					
				}
			},
            allowNext() {
                if (this.report.scoreHygiene == 0) {
                    return false;
                }

                if (this.report.scoreFasteners == 0) {
                    return false;
                }

                if (this.report.scoreProtection == 0) {
                    return false;
                }

                if (typeof this.selectedApron == 'undefined') {
                    return false;
                }

                return true;
            },
            cptNextInspectionDate: {
                get: function () {
                    return general.toHTML5date(this.report.nextInspection);
                },
                set: function (newContent) {
                    this.report.nextInspection = new Date(newContent).toISOString()
                }
            },
            report: {
                get: function () {
                    return this.$store.state.report;
                },
                set: function (newContent) {
                    this.$store.commit('SET_report', newContent);
                }
            },
            ...mapGetters({
                WorkList: 'ApronInspectionNeeded',
                isOnEdge: 'isOnEdge',
                isOutOfTolerance: 'isOutOfTolerance',
                allowSubmit: 'allowSubmitReport'
            }),
            ...mapState({
                tolerance: state => state.config.tolerance,

            }),

        },
        methods: {
            GetEmptyReport() {
                axios.get('/ReportPage/GetEmptyReport')
                    .then((response) => {
                        this.report = response.data;
                        this.report.apronID = this.$route.params.slug;

                        var nextInspection = new Date();
                        nextInspection.setDate(nextInspection.getDate() + 365);

                        this.cptNextInspectionDate = nextInspection

                        //Reset form
                        this.lstFilesToUpload = new FormData();
                        this.currentStep = 1;
                        this.lstFileNames = []

                        //Default should be excellent
                        this.report.scoreProtection = 5
                        this.report.scoreHygiene = 5
                        this.report.scoreFasteners = 5

                    })
                    .catch(function (error) {
                        alert(error);
                    });
            },
            DeletePhoto(index) {
                this.lstFileNames.splice(index, 1);
            },
            SubmitReport(x, model, category) {

                var val = x;
                var name = model;
                var cat = category

                //Let store know we are saving data
                this.lstFilesToUpload.append("strReport", JSON.stringify(this.report));

                axios.post('/ReportPage/SubmitReport', this.lstFilesToUpload, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                    .then((response) => {
                        if (response.status == '200') {

                            if (response.data == "AccessForbidden") {
                                this.$router.push({ name: 'DashboardHome' })
                            }


                            //deep clone and update
                            var futureApron = JSON.parse(JSON.stringify(this.selectedApron))

                            // if in tolerance, update apron status in store
                            if (this.isOutOfTolerance == false) {
                                futureApron.status = 1 // to OK status
								this.$store.commit('ADDorUPDATE_lstAllAprons', { newValue: futureApron, blnIsNewItem: false } )
                            } else {
                                if (this.report.ApproveAnyway) {
                                    futureApron.status = 6 // to OK for now status
									this.$store.commit('ADDorUPDATE_lstAllAprons', { newValue: futureApron, blnIsNewItem: false }  )
                                } else {
                                    futureApron.status = 4 // to discarded status

                                    //Remove from store
                                    this.$store.commit('REMOVE_lstAllAprons', [futureApron.apronID])

                                    //Refresh discarded list
                                    this.$store.dispatch('GET_lstDiscardedAprons')
                                }

                            }

                            //Close modal (can be open at this stage)
                            Bus.$emit('close-modal');


                            //Reset form
                            this.GetEmptyReport()

                            //navigate to confirmation + worklist
                            this.$router.push({ name: 'Worklist', params: { CallToAction: val, model: name, category: cat } })
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    }
                    );


            },
            AppendFileList(fileList) {

                this.uploadBusy = true
                //Sets the currently selected files to the data
                this.fileValidation = []
                               

                if (fileList.length > 5) {
					this.fileValidation.push(this.$t('reportPage.surplusIgnored'))
                }

                for (var i = 0; i < fileList.length; i++) {
                    
                    if (fileList[i].size > 4194304) {
						this.fileValidation.push(this.$t('reportPage.fileTooLarge', [fileList[i].name]))
                        continue;
                    }

                    if (fileList[i].name.includes('.zip') || fileList[i].name.includes('.rar')) {
						this.fileValidation.push(this.$t('reportPage.compressedArchves', [fileList[i].name]))
                        continue;
                    }

                    // save url in obj
                    var srcImage = URL.createObjectURL(fileList[i]);

                    var obj = { "name": fileList[i].name, "src": srcImage };

                    this.lstFileNames.push(obj);
                    this.lstFilesToUpload.append("file", fileList[i], fileList[i].name);

                }

				this.uploadBusy = false

            },
            toHTML5date: general.toHTML5date
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
